// // import the interface

// import { Action } from "@ngrx/store";
// import { VesselRotationActionType } from "../actions/vessel-rotation.action";
// import { VesselRotationFilter } from "../vessel-rotation-filter.model";

// //create a dummy initial state
// const initialState: VesselRotationFilter = 
//     {
//         // Define the properties of your default VesselRotationFilter object
//         // For example:
//         terminalId: 0,
//         vessels: [],
//         // Add more properties as needed
//       }
// // Reducer Logic
// // Reducer Logic
// export function VesselRotationReducer(
//     state: VesselRotationFilter = initialState,
//     action: any
//   ) {
//     console.log('VesselRotationReducer');
//     switch (action.type) {
//         case VesselRotationActionType.TERMINAL_CHANGE:
//             // Check if the terminalId already exists in the state
//             const existingData = state[action.payload.terminalId];
//             // If the terminalId exists, update the data, otherwise insert it
//             if (existingData) {
//                 return {
//                     ...state,
//                     [action.payload.terminalId]: {
//                         ...existingData,
//                         ...action.payload
//                     }
//                 };
//             } else {
//                 return {
//                     ...state,
//                     [action.payload.terminalId]: action.payload
//                 };
//             }
//         case VesselRotationActionType.COUNTER:
//             console.log(action);
//             // Directly return the new payload as the state
//             return action.payload;
//         default:
//             return state;
//     }
    
//   }
  
import { createReducer, on } from '@ngrx/store';
import { setVesselRotations } from '../actions/vessel-rotation.action';
import { VesselRotationsState } from '../vessel-rotation-filter.model';


export const initialState: VesselRotationsState = {
  rotations: []
};

export const vesselRotationReducer = createReducer(
    initialState,
    on(setVesselRotations, (state, { rotations }) => {
      // Create a copy of the current rotations array
      const updatedRotations = [...state.rotations];
      
      // Iterate through the rotations provided in the action payload
      rotations.forEach(rotation => {
        // Check if the terminalId already exists in the state
        const existingIndex = updatedRotations.findIndex(rot => rot.terminalId === rotation.terminalId);
        if (existingIndex !== -1) {
          // If the terminalId exists, update the data
          updatedRotations[existingIndex] = rotation;
        } else {
          // If the terminalId doesn't exist, insert the data
          updatedRotations.push(rotation);
        }
      });
  
      // Return the updated state with the modified rotations array
      return {
        ...state,
        rotations: updatedRotations
      };
    })
  );
